module.exports = __webpack_public_path__ + "img/LogoTribunal.1e25acf0.png";